/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Route from 'solis/route';
import Routes from 'solis/enum/route';

import Connecting from 'solis/claude/layout/connecting';

import PendingRedirect from 'solis/auth/pending.redirect';


export const PUBLIC_ROUTES = [ Routes.Terms, Routes.Privacy ];


export default ({ children }) =>
{
  const route = use(Route);

  const galaxy = use(Galaxy);

  if (PUBLIC_ROUTES.includes(route.getType()))
  {
    return children;
  }

  if (galaxy == null || galaxy.getCurrentAccount() == null)
  {
    return (
      <>
        <PendingRedirect />
        <Connecting />
      </>
    );
  }

  return children;
};
